import { useEffect, useState } from 'react';
import LeftSidePopupLayout from './modal-layout';
import XCloseIcon from '../icons/x-close';
import Style from './style.module.css'
import { useApiCall } from '../custom-hooks/api-call';
import { useFormik } from 'formik';
import * as yup from "yup";
import { File, UploadCloud } from 'lucide-react';
import InnerLoader from '../ui/loader/inner-loader';
import { Link } from 'react-router';

const VendorModal = ({ onSubmit = () => { }, onClose = () => { }, onError = () => { }, type = "", vendorData }) => {
  const apiCall = useApiCall();
  const [logoError , setLogoError] = useState(false);
  const [contractError , setContractError] = useState(false);
  const [activeBar , setActiveBar] = useState("car")

  useEffect(() => {
    if (vendorData?.id || vendorData?.vid) {
      formik.setFieldValue("vendorName", vendorData?.vendor_name || "")
      formik.setFieldValue("companyName", vendorData?.vendor_company_name || "")
      formik.setFieldValue("phone", vendorData?.vendor_phone || "")
      formik.setFieldValue("email", vendorData?.vendor_email || "")
      formik.setFieldValue("companyLogo", vendorData?.vendor_logo || "")
      formik.setFieldValue("contract", vendorData?.contract_document || "")
      formik.setFieldValue("is_active", vendorData?.status == "Active" ? "yes" : "no")
      setActiveBar(type)
    }
  }, [])

  const validationSchema = yup.object({
    vendorName: yup
      .string('This Field is Required')
      .required('This Field is Required'),
    companyName: yup
      .string('This Field is Required')
      .required('This Field is Required'),
    phone: yup
      .string('This Field is Required')
      .required('This Field is Required'),
    email: yup
      .string('This Field is Required')
      .required('This Field is Required'),
    contract_expiry_date: yup
      .string('This Field is Required')
      .required('This Field is Required'),
    // companyLogo: yup
    //   .string('This Field is Required')
    //   .required('This Field is Required'),
    // contract: yup
    //   .string('This Field is Required')
    //   .required('This Field is Required'),
    is_active: yup
      .string('This Field is Required')
      .required('This Field is Required'),
  });

  const formik = useFormik({
    initialValues: {
      vendorName: '',
      companyName: '',
      phone: '',
      email: '',
      companyLogo: '',
      contract: '',
      is_active: '',
      contract_expiry_date: '',
      companyLogoLoader: false,
      contractLoader: false
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {

      console.log("values", values)

      let extraData = {};

      if (vendorData?.id || vendorData?.vid) {
        extraData = {
          "vendor_id": vendorData?.id || vendorData?.vid
        }
      }

      let data = {
        ...extraData,
        "contract_expiry_date": values?.contract_expiry_date,
        "vendor_name": values?.vendorName,
        "vendor_phone": values?.phone,
        "vendor_email": values?.email,
        "vendor_logo": values?.companyLogo,
        "vendor_company_name": values?.companyName,
        "contract_document": values?.contract,
        "status": (values?.is_active == "yes") ? "1" : "0"
      }

      try {
        let apiRes = await apiCall({ method: "post", url: (vendorData?.id || vendorData?.vid) ? (activeBar == "car") ? 'edit-vendor-fleet' : `edit-van-vendor-fleet` : (activeBar == "car") ? "add-vendor-fleet" : "add-van-vendor-fleet", data: data })
        formik.resetForm();
        onSubmit(apiRes?.message || `Request Submitted`);
      } catch (error) {
        console.log("Error", error)
        onError(error?.response.data?.respMsg || error?.response.data?.responseMessage || error?.response.data?.message || "Some Thing Went Wrong")
      }

    },
  });

  const handleFileUpload = async (file, type) => {
    let apiData = new FormData();
    apiData.append('file', file);
    if(type == "companyLogo"){
      setLogoError(false);
      formik.setFieldValue("companyLogo", "");
      formik.setFieldValue("companyLogoLoader", true);
    }else{
      setContractError(false);
      formik.setFieldValue("contract", "");
      formik.setFieldValue("contractLoader", true)
    }
    try {
      let apiRes = await apiCall({ method: "post", url: "upload", data: apiData });
      if(type == "companyLogo"){
        formik.setFieldValue("companyLogo", apiRes?.path?.filepath);
        formik.setFieldValue("companyLogoLoader", false);
      }else{
        formik.setFieldValue("contract", apiRes?.path?.filepath);
        formik.setFieldValue("contractLoader", false)
      }
      console.log("apiRes", apiRes?.path?.filepath, type);
    } catch (error) {
      console.log("Error", error)
    }
  }

  return (
    <form onSubmit={formik.handleSubmit}>
      <LeftSidePopupLayout popupStatus={true} className={`${Style.addMeModal} ${Style.leaveModal} !gap-0`}>
        <div className={`${Style["modal_header"]} ${type ? Style.addMeModal_head : ""} !bg-white !block`}>
          <div className="flex items-center justify-between">
            <h4>{(vendorData?.id || vendorData?.vid) ? "Update" : "Add"} Vendor</h4>
            <div onClick={onClose} className={`${Style["close_btn"]} cursor-pointer`}><XCloseIcon /></div>
          </div>
          {!type ?
            <div className={Style.modal_nav}>
              <ul className='pt-3'>
                <li className={activeBar == "car" ? Style.active : ""} onClick={() => {setActiveBar("car")}}>Car</li>
                <li className={activeBar == "van" ? Style.active : ""} onClick={() => {setActiveBar("van")}}>Van</li>
              </ul>
            </div>
            :
            null
          }
        </div>

        <div className={`${Style.addMeModal_body}`}>
          <div className={`${Style.dcmb__card}`}>
            <div className={`${Style.dcmb__cardBody}`}>
              <div className={`${Style.dcmb__cardBody_formArea} pt-3`}>
                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Vendor Name</label>
                    <input
                      type="text"
                      name='vendorName'
                      value={formik.values.vendorName}
                      onChange={formik.handleChange}
                      placeholder='Vendor Name'
                    />
                    {
                      (formik.touched.vendorName && Boolean(formik.errors.vendorName)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.vendorName && formik.errors.vendorName}</span>
                        :
                        null
                    }
                  </div>
                </div>

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Company Name</label>
                    <input
                      type="text"
                      name='companyName'
                      value={formik.values.companyName}
                      onChange={formik.handleChange}
                      placeholder='Company Name'
                    />
                    {
                      (formik.touched.companyName && Boolean(formik.errors.companyName)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.companyName && formik.errors.companyName}</span>
                        :
                        null
                    }
                  </div>
                </div>

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Phone</label>
                    <input
                      type="text"
                      name='phone'
                      value={formik.values.phone}
                      onChange={formik.handleChange}
                      placeholder='Phone Number'
                    />
                    {
                      (formik.touched.phone && Boolean(formik.errors.phone)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.phone && formik.errors.phone}</span>
                        :
                        null
                    }
                  </div>
                </div>

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Email</label>
                    <input
                      type="text"
                      name='email'
                      value={formik.values.email}
                      onChange={formik.handleChange}
                      placeholder='Email Address'
                    />
                    {
                      (formik.touched.email && Boolean(formik.errors.email)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.email && formik.errors.email}</span>
                        :
                        null
                    }
                  </div>
                </div>

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Contract Expiry Date</label>
                    <input
                      type="date"
                      name='contract_expiry_date'
                      value={formik.values.contract_expiry_date}
                      onChange={formik.handleChange}
                    />
                    {
                      (formik.touched.contract_expiry_date && Boolean(formik.errors.contract_expiry_date)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.contract_expiry_date && formik.errors.contract_expiry_date}</span>
                        :
                        null
                    }
                  </div>
                </div>

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Company Logo</label>
                    <label
                      onDrop={(e) => { e.preventDefault(); handleFileUpload(e.dataTransfer.files?.[0], "companyLogo") }}
                      onDragOver={(e) => e.preventDefault()}
                      className="flex flex-col !items-center justify-center w-full h-40 border-2 border-dashed border-gray-300 rounded-2xl cursor-pointer bg-gray-50 hover:bg-gray-100 transition"
                    >
                      {formik?.values?.companyLogoLoader ?
                        <InnerLoader wrapperClass="!w-10 !h-10" textStatus={false} />
                        :
                        <UploadCloud className="w-10 h-10 text-gray-500 mb-2" />
                      }
                      <p className="text-gray-600 font-medium">Drag & Drop files here</p>
                      <p className="text-sm text-gray-400">or click to browse</p>
                      <input
                        type="file"
                        onChange={(e) => { handleFileUpload(e.target.files[0], "companyLogo") }}
                        className="hidden"
                      />
                    </label>
                    {formik.values?.companyLogo ?
                      <div className="">
                        <Link to={formik.values?.companyLogo} target='_blank' className='inline-block'>
                          {logoError ?
                            <div className="h-20 w-20 shrink-0 rounded-md bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium">
                              <File />
                            </div>
                            :
                            <img src={formik.values?.companyLogo} alt={formik?.values?.companyName} className='h-20 w-20 rounded-md' onError={(e) => {
                              e.target.classList.add("hidden");
                              setLogoError(true);
                              // if (e.target.parentElement) {
                              //   e.target.parentElement.innerHTML =
                              //     `<div className="h-20 w-20 shrink-0 rounded-md bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium">
                              //       ${<File />}
                              //     </div>`
                              // }
                            }} />
                          }
                        </Link>
                      </div>
                      :
                      null
                    }
                    {
                      (formik.touched.companyLogo && Boolean(formik.errors.companyLogo)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.companyLogo && formik.errors.companyLogo}</span>
                        :
                        null
                    }
                  </div>
                </div>

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Contract Document</label>
                    <label
                      onDrop={(e) => { e.preventDefault(); handleFileUpload(e.dataTransfer.files?.[0], "contract") }}
                      onDragOver={(e) => e.preventDefault()}
                      className="flex flex-col !items-center justify-center w-full h-40 border-2 border-dashed border-gray-300 rounded-2xl cursor-pointer bg-gray-50 hover:bg-gray-100 transition"
                    >
                      {formik?.values?.contractLoader ?
                        <InnerLoader wrapperClass="!w-10 !h-10" textStatus={false} />
                        :
                        <UploadCloud className="w-10 h-10 text-gray-500 mb-2" />
                      }
                      <p className="text-gray-600 font-medium">Drag & Drop files here</p>
                      <p className="text-sm text-gray-400">or click to browse</p>
                      <input
                        type="file"
                        onChange={(e) => { handleFileUpload(e.target.files[0], "contract") }}
                        className="hidden"
                      />
                    </label>
                    {formik.values?.contract ?
                      <div className="">
                        <Link to={formik.values?.contract} target='_blank' className='inline-block'>
                          {contractError ?
                            <div className="h-20 w-20 shrink-0 rounded-md bg-gradient-to-br from-indigo-500/20 to-emerald-500/20 grid place-items-center text-xs font-medium">
                              <File />
                            </div>
                            :
                            <img src={formik.values?.contract} alt={formik?.values?.companyName} className='h-20 w-20 rounded-md' onError={(e) => {
                              e.target.classList.add("hidden");
                              setContractError(true);
                            }} />
                          }
                        </Link>
                      </div>
                      :
                      null
                    }
                    {
                      (formik.touched.contract && Boolean(formik.errors.contract)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.contract && formik.errors.contract}</span>
                        :
                        null
                    }
                  </div>
                </div>

                <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                  <div className={`${Style["dcmb__cardBody_formArea_feild"]}`}>
                    <label htmlFor="">Active</label>
                    {/* <input type="date" placeholder='Type Here' /> */}
                    <div className="flex items-center gap-6">
                      <div className="flex items-center gap-1">
                        <input
                          className='!h-5'
                          type="radio"
                          name='is_active'
                          checked={formik.values?.is_active == "yes"}
                          id='activeYes'
                          value={"yes"}
                          onChange={formik.handleChange}
                        // placeholder='Type is_active In Number'
                        />
                        <label htmlFor="activeYes" className='!h-5'>Yes</label>
                      </div>

                      <div className="flex items-center gap-1">
                        <input
                          className='!h-5'
                          type="radio"
                          name='is_active'
                          id='activeNo'
                          value={"no"}
                          checked={formik.values?.is_active == "no"}
                          onChange={formik.handleChange}
                        />
                        <label htmlFor="activeNo" className='!h-5'>No</label>
                      </div>
                    </div>
                    {
                      (formik.touched.is_active && Boolean(formik.errors.is_active)) ?
                        <span style={{ color: "red" }} className='ps-1'>{formik.touched.is_active && formik.errors.is_active}</span>
                        :
                        null
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className={`${Style.dcmb__cardFoot}`}>
          <button type='reset' className={`${Style.dcmb__cancel}`} onClick={onClose}>Discard</button>
          <button type='submit' className={`${Style.dcmb__submit}`}>Apply</button>
        </div>
      </LeftSidePopupLayout>
    </form>
  )
}

export default VendorModal